import { Subject } from "rxjs";

export interface ProgramAccessDialogRequest {
  /** the job: a checkpoint program, its fileset and entry function */
  jobUid: string;
  /** the job's name, for the title */
  jobName: string;
}

/** Emit a request to open the program access dialog, or undefined to close it. Kept out of the .tsx so
 *  the dialog module exports only components (a React Fast Refresh requirement). */
export const showProgramAccessDialog = new Subject<ProgramAccessDialogRequest | undefined>();

export function openProgramAccessDialog(req: ProgramAccessDialogRequest): void {
  showProgramAccessDialog.next(req);
}
